<template>
  <div class="forms">
    <drag-modal :visible="visible" :title='edit == 1 ? "延期" : "查看"' width='410px' class="disform" @cancel='rest'>
      <a-form-model ref="forms" :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" :rules="rules">
        <a-form-model-item label="延期时间" prop="delay_time"
          :rules="{ required: true, message: '请选择延期时间', trigger: 'change' }">
          <a-date-picker v-model="form.delay_time" placeholder="请选择" style="width: 100%;" format="YYYY-MM-DD"
            :disabled="edit == 0" valueFormat="YYYY-MM-DD" />
        </a-form-model-item>
        <a-form-model-item label="延期原因" prop="delay_reason"
          :rules="{ required: true, message: '请输入延期原因', trigger: 'blur' }">
          <Ntxt :content='form.delay_reason' :max='200' Hei='108px' :edit='edit == 0'
            @contentVal='(e) => { form.delay_reason = e }'></Ntxt>
        </a-form-model-item>
        <a-form-model-item v-if='edit == 1' style="margin-bottom:0;">
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
            <a-button type="primary" style="width: 132px;height: 32px;margin:0 0 0 74px;">
              确定
            </a-button>
          </a-popconfirm>
        </a-form-model-item>
      </a-form-model>
    </drag-modal>
    <div class="h22">
      <a-radio-group v-model='status' @change="resh">
        <a-radio-button :value="1">提醒中({{ top.remindCount }})</a-radio-button>
        <a-radio-button :value="2">已延期({{ top.remindDelayCount }})</a-radio-button>
      </a-radio-group>
      <div class="mid" v-if="status == 1">
        <!-- <a-checkbox v-model="checked" @change="resh">即将超期({{Nums}})</a-checkbox> -->
        <a href="javascript:void(0);" :class="{ 'cur': nkType == 1 }" @click="pickMonth(1)">普通提醒({{
          top.normalRemindCount }})</a>
        <a href="javascript:void(0);" :class="{ 'cur': nkType == 2 }" @click="pickMonth(2)">即将超期({{
          top.adventRemindCount }})</a>
        <a href="javascript:void(0);" :class="{ 'cur': nkType == 3 }" @click="pickMonth(3)">已超期({{ top.expireRemindCount
        }})</a>
      </div>
    </div>
    <div class="table">
      <Table :formKey='putData.formKey[status]' :getUrl='putData.url' ID='id' ref='table'
        :query='{ status: status, start_last_compensation_time: tform.start_last_compensation_time, end_last_compensation_time: tform.end_last_compensation_time }'
        :other='["delay_time", "delay_reason", "debtor_id"]' v-if='$common.AUTH("welcome:causeAging:index")'>
        <template v-slot:pick='v'>
          <div class="fbtns">
            <span v-if='$common.AUTH("debtor:info") && $common.AUTH("welcome:causeAging:index")'>
              <router-link :to='{ "name": "lydetails", params: { "id": v.other[2] } }' class="curpoter" target="_blank"
                style='color: #1d8bfe;'> 查看</router-link>
            </span>
            <span @click='form.id = v.id; edit = 1; visible = true;'
              v-if='status == 1 && $common.AUTH("welcome:causeAging:delay")'>延期</span>
            <a-popover :content="v.other[1]" v-if='status == 2'>
              <span>延期原因</span>
            </a-popover>
          </div>
        </template>
      </Table>
      <div class="nqx smnq" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>
  </div>
</template>
<script>
import Ntxt from '@/components/textarea/ntxt'
import Table from './table.vue'
import { delayed } from '@/server/api'
import { diffMonth } from '@/assets/js/formData'
import { ajax } from '@/assets/js/ajax.js'
const TimeArr = [
  { now: diffMonth(-30), later: '2093-7-13' },
  { now: diffMonth(-36), later: diffMonth(-30) },
  { now: "1993-7-13", later: diffMonth(-36) },
]
export default {
  name: 'Time',
  props: { putData: Object },
  data() {
    return {
      edit: 0, //0查看 1设置
      rules: {},
      visible: false,
      time: [],
      checked: false,
      Nums: 0,
      nkType: null,
      topNums: [0, 0, 0],
      form: {
        id: null,
        delay_time: "",
        delay_reason: ""
      },
      status: 1
    }
  },
  components: { Ntxt, Table },
  computed: {
    top() {
      return this.$store.state.Home.Top
    },
    tform() {
      if (this.nkType && this.status == 1) {
        return {
          start_last_compensation_time: TimeArr[this.nkType * 1 - 1].now,
          end_last_compensation_time: TimeArr[this.nkType * 1 - 1].later
        }
      }
      else {
        return {}
      }
    },
  },
  created() {
    // this.getNums()
  },
  methods: {
    pickMonth(type) {
      if (!this.nkType || this.nkType != type) {
        this.nkType = type
      } else {
        this.nkType = null
      }
      this.resh()
    },
    // getNums() {
    //   if (this.$common.AUTH('welcome:causeAging:index')) {
    //     let getCodeList = (v) => {
    //       return new Promise((resolve, reject) => {
    //         ajax({
    //           url: 'welcome/causeAging/index', //url
    //           data: {
    //             status: 1,
    //             start_last_compensation_time: v.now,
    //             end_last_compensation_time: v.later,
    //             page: 1,
    //             limit: 1
    //           },
    //           type: 'get',
    //           success: (e) => {
    //             resolve(e.count)
    //           },
    //         })
    //       })
    //     }
    //     let getAll = async () => {
    //       //循环抛请求
    //       let result = await Promise.all(
    //         TimeArr.map((ele) => {
    //           return getCodeList(ele)
    //         })
    //       )
    //       return result
    //     }
    //     getAll().then((res) => {
    //       //初始状态进行请求
    //       this.topNums = res
    //     })
    //   }
    // },
    rest() {
      let form = JSON.parse(JSON.stringify(this.form))
      for (let val in form) {
        form[val] = ''
      }
      this.form = form
      this.visible = false;
      // this.getNums()
    },
    resh() {
      // this.getNums()
      setTimeout(e => {
        this.$refs.table.resh()
      }, 200)
    },
    see(v) {
      this.form.id = v.id;
      this.form.delay_time = v.other[0]
      this.form.delay_reason = v.other[1]
      this.visible = true;
      this.edit = 0;
    },
    confirm() {
      this.$refs.forms.validate(valid => {
        if (valid) {
          delayed(this.form).then(e => {
            this.rest()
            this.$refs.table.turnpage()
            // this.getNums()
            this.$message.success("已设置延期")
          })
        } else {
          console.log("error")
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.disform {
  /deep/ .ant-form-item {
    margin-bottom: 14px;
  }

  /deep/ .ipt input {
    padding-right: 50px;
  }

  .file {
    width: 200px;
    height: 32px;
    border-radius: 4px;
    border: 1px solid #efefef;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    position: relative;
    margin-top: 4px;

    .fbox {
      position: relative;
      color: #1d8bfe;

      input {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
      }
    }
  }
}

.mid {
  overflow: hidden;
  margin-left: 20px;

  a {
    position: relative;
    display: inline-block;
    height: 30x;
    margin: 0;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 30px;
    background: #fff;
    border: 1px solid #d9d9d9;

    &:nth-child(1) {
      border-left: 1px solid #d9d9d9;
      border-radius: 4px 0 0 4px;
    }

    &:nth-child(3) {
      border-radius: 0 4px 4px 0;
    }
  }

  .cur {
    z-index: 1;
    color: #1890ff;
    background: #fff;
    border-color: #1890ff !important;
  }
}

.h22 {
  display: flex;

  .rt {
    margin-left: 20px;

    label {
      margin-right: 10px;
    }
  }
}
</style>